import React, { useState } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import MemberForm from '../components/MemberForm';
import MessageModal from '../components/MessageModal';
import { registerMember } from '../services/api/memberService';
import '../styles/RegisterMember.css';

const RegisterMemberPage = () => {
  const { id } = useParams(); // Member type / id
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [language, setLanguage] = useState('ID');

  // Simple translation function
  const t = (en, id) => (language === 'EN' ? en : id);

  const handleRegister = async (data, language) => {
    setLoading(true);
    setError('');
    setSuccess(false);
    setLanguage(language);

    const result = await registerMember(data);

    if (result.success) {
      setSuccess(true);
    } else {
      setError(result.message);
    }

    setLoading(false);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    if (success) {
      navigate('/login'); // Redirect ke login kalau register sukses
    }
  };

  return (
    <>
      <MemberForm 
        onSubmit={handleRegister} 
        onCancel={() => navigate('/login')} // Cancel → ke login
        isEdit={false}
        member_type={id}
        loading={loading}
      />

      {isModalOpen && (
        <MessageModal 
          onClose={handleCloseModal}
          title={
            success
              ? t('Registration Successful', 'Pendaftaran Berhasil')
              : t('Registration Failed', 'Pendaftaran Gagal')
          }
          message_content={
            success
              ? t(
                  'Your registration has been successfully saved, please wait for admin approval to become a member.',
                  'Pendaftaran anda sudah berhasil disimpan, mohon tunggu approval dari admin untuk menjadi anggota.'
                )
              : error
          }
          icon={success ? <FaCheckCircle /> : <FaTimesCircle />}
          button_name={t('Close', 'Tutup')}
          isSuccess={success}
        />
      )}
    </>
  );
};

export default RegisterMemberPage;
